import React from 'react'
import './Jobs.scss'

function Jobs() {
  return (
    <div className="jobs">
      <h2>Aktuelle Jobangebote</h2>
      <div className="jobs__list">
        <a className="job"
           href="./jobanzeige_werkstudent_marketingmanagement.pdf"
           target="_blank"
           rel="noopener noreferrer">
          <div className="job__card">
            <div className="job__title">
              Werkstudent (m/w/d) Marketing-Management
            </div>
            <div className="job__description">
              <span>Festanstellung, Teilzeit</span>
              <span> · </span>
              <span>Hof</span>
            </div>
          </div>
          <div className="job__link">
            <div className="arrow"></div>
          </div>
        </a>
      </div>
    </div>
  )
}

export default Jobs
